export enum DateAttributeType {
	DATE = 'DATE',
	DATE_TIME = 'DATE_TIME'
}
